import { render } from "./LightBox.vue?vue&type=template&id=c9aa71c0&scoped=true"
import script from "./LightBox.vue?vue&type=script&lang=js"
export * from "./LightBox.vue?vue&type=script&lang=js"

import "./LightBox.vue?vue&type=style&index=0&id=c9aa71c0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9aa71c0"]])

export default __exports__